import api from "../api";

class ExpenseService {
	GetFormattedDate(date) {
		if (date == null || date === "") {
			return "";
		}

		let month = date.getMonth() + 1,
			day = date.getDate(),
			year = date.getFullYear();

		return month + "/" + day + "/" + year;
	}

	async getAllExpenses(filters) {
		return new Promise((res, reject) => {
			let f = filters || {};

			let params = {
				page: f.page || 0,
				pageSize: f.pageSize || 10,
				startDate: f.startDate || "",
				endDate: f.endDate || "",
				users: f.users || [],
			};
			api
				.get("/expenses", params)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	//exec spExpenseExport '1/1/2019', '3/7/2019','2,3,5'
	async getExpensesForCSV(filters) {
		return new Promise((res, reject) => {
			api
				.get("/expensesCSVNative", filters)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async getExpense(id) {
		return new Promise((res, reject) => {
			api
				.get("/expenses/" + id)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async updateExpense(expense) {
		return new Promise((res, reject) => {
			api
				.put("/activities/" + expense.id, expense)
				.then((data) => {
					res(data);
				})
				.catch((err) => {
					reject();
				});
		});
	}

	async createExpense(expense) {
		return api.post("/activities/", expense);
	}
}

const expenseService = new ExpenseService();

export default expenseService;
